// @ts-nocheck
import * as React from "react";
import { ManualMobileShell, Section, Lead, Steps, Note, GoTo, ShotMobile, FlowStripMobile } from "./manual-shell";
import { supportPhone } from "./common";

// 케어매니저 사용자 매뉴얼 — 모바일(폰) 인앱 가이드.
// 진입점은 모바일 홈(/m/home) 헤더 우측 상단의 "사용자 매뉴얼" 버튼(mobile-manager.tsx).
// 콘텐츠는 manager 의 실제 모바일 현장 업무(일정→내비→방문→체크인→기록) 흐름에 맞췄다.
// 셸/프리미티브는 manual-shell.tsx(ManualMobileShell·ShotMobile·FlowStripMobile)에서 가져온다.

// 실제 화면 스크린샷 경로 — playwright test e2e/manual-shots/manager.gen.spec.ts 로
// 생성(public/manual-shots/manager/, 세로 390×844 폰 캡처).
const S = (key) => `/manual-shots/manager/${key}.png`;

const TOC = [
  { id: "start",    label: "시작하기" },
  { id: "home",     label: "홈" },
  { id: "schedule", label: "일정" },
  { id: "map",      label: "지도·내비" },
  { id: "visit",    label: "방문" },
  { id: "report",   label: "방문 기록" },
  { id: "cases",    label: "케이스" },
  { id: "chat",     label: "메시지" },
  { id: "match",    label: "매칭 제안" },
  { id: "reports",  label: "기록 조회" },
  { id: "me",       label: "내 정보" },
  { id: "flow",     label: "업무 흐름" },
  { id: "faq",      label: "FAQ" },
];

const INTRO = (
  <>
    이 매뉴얼은 케어매니저가 현장에서 휴대폰으로 수행하는 업무를 화면 흐름에 맞춰 안내합니다.
    오늘 일정 확인부터 내비게이션, 방문 체크인/체크아웃, 방문 기록 작성, 매칭 제안 처리까지
    하루 업무 전반을 다룹니다. 화면 하단의 <b>5개 탭(홈·일정·지도·케이스·마이)</b>으로 이동합니다.
  </>
);

function ManagerManual() {
  return (
    <ManualMobileShell
      badge="CARE MANAGER GUIDE"
      title="케어매니저 사용자 매뉴얼"
      revised="최종 개정 2026-06-18 · 케어매니저(manager) 기준 · 화면 캡처 최신화"
      intro={INTRO}
      toc={TOC}
      tab="home"
    >
      <Section id="start" title="1. 시작하기">
        <Lead>케어매니저는 휴대폰 앱으로 현장 돌봄을 수행합니다. 로그인하면 자동으로 모바일 홈(/m/home)으로 이동합니다.</Lead>
        <Steps items={[
          "발급받은 케어매니저 계정으로 로그인합니다.",
          "화면 하단 5개 탭으로 이동합니다 — 홈 · 일정 · 지도 · 케이스 · 마이.",
          "홈 상단에서 오늘 방문 요약과 다음 방문, 알림을 확인합니다.",
          "도움이 필요할 때는 홈 우측 상단의 '사용자 매뉴얼' 버튼으로 언제든 이 화면에 돌아옵니다.",
        ]} />
        <GoTo links={[{ href: "/m/home", label: "홈 열기" }]} />
      </Section>

      <Section id="home" title="2. 홈">
        <Lead>오늘의 업무를 한눈에 봅니다. 다음 방문 카드, 오늘/담당/주간 요약, 새 매칭 제안 배너, 오늘 방문 목록이 표시됩니다.</Lead>
        <Steps items={[
          "다음 방문 카드에서 시간·장소·거리·위험도·복약 수를 확인합니다.",
          "'출발 · 내비' 버튼으로 길찾기를, 보호자 전화 버튼으로 연락합니다.",
          "상단 종 아이콘으로 알림함에 들어가 새 알림을 확인합니다.",
          "오늘 방문 목록에서 방문을 눌러 상세로 들어갑니다.",
        ]} />
        <ShotMobile src={S("home")} alt="매니저 홈 화면" caption="홈 — 다음 방문 카드·오늘 요약·방문 목록 (탭하면 원본 크기)" />
        <GoTo links={[{ href: "/m/home", label: "홈 열기" }]} />
      </Section>

      <Section id="schedule" title="3. 일정">
        <Lead>날짜별 내 방문 일정을 확인하고, 필요하면 직접 방문을 추가합니다.</Lead>
        <Steps items={[
          "하단 '일정' 탭에서 주 단위로 방문(방문·완료·예정 수, 주간 시간)을 봅니다.",
          "방문을 눌러 상세(방문 화면)로 이동합니다.",
          "우측 하단 '+' 버튼으로 본인 방문 일정을 직접 추가합니다(어르신·날짜·시간 입력).",
        ]} />
        <ShotMobile src={S("schedule")} alt="내 일정 화면" caption="일정 — 날짜별 방문 목록" />
        <GoTo links={[{ href: "/m/schedule", label: "일정 열기" }]} />
      </Section>

      <Section id="map" title="4. 지도·내비">
        <Lead>다음 방문 어르신 위치를 지도에서 보고 내비게이션을 시작합니다.</Lead>
        <Steps items={[
          "하단 '지도' 탭에서 다음 방문 위치 핀을 확인합니다.",
          "내비 앱(네이버·T맵·카카오·구글)을 선택해 길찾기를 시작합니다.",
          "자주 쓰는 내비를 기본값으로 저장할 수 있습니다.",
        ]} />
        <ShotMobile src={S("map")} alt="지도·내비 화면" caption="지도·내비 — 방문지 위치와 내비 앱 선택" />
        <GoTo links={[{ href: "/m/map", label: "지도 열기" }]} />
      </Section>

      <Section id="visit" title="5. 방문 (체크인·체크아웃)">
        <Lead>현장에 도착하면 방문 상세에서 체크인하고, 방문이 끝나면 체크아웃합니다.</Lead>
        <Steps items={[
          "방문 상세에서 어르신의 건강 상태·복약 정보를 확인합니다.",
          "도착하면 '체크인'으로 방문을 시작합니다(진행중).",
          "방문 중 메모를 작성·저장합니다.",
          "방문이 끝나면 '체크아웃'으로 종료하고 방문 기록 작성으로 이어집니다.",
        ]} />
        <ShotMobile src={S("visit")} alt="방문 상세 화면" caption="방문 상세 — 체크인/체크아웃·메모·건강 정보" />
        <GoTo links={[{ href: "/m/visit", label: "방문 상세 열기" }]} />
      </Section>

      <Section id="report" title="6. 방문 기록 작성">
        <Lead>방문 후 컨디션과 활력징후, 특이사항을 기록하고 현장 사진을 첨부합니다.</Lead>
        <Steps items={[
          "오늘 어르신 컨디션(좋음·보통·나쁨·위급)을 선택합니다.",
          "혈압·맥박·체온 활력징후를 입력합니다(위험 범위면 즉시 경고가 표시됩니다).",
          "가족에게 공유될 특이사항 메모를 작성하고, 현장 사진을 첨부합니다(JPG·PNG·WebP).",
          "임시저장으로 작성 중인 내용을 보관하거나, 제출로 기록을 완료합니다.",
        ]} />
        <Note>방문 기록은 작성 후 <b>24시간 이내</b>에만 본인이 수정할 수 있습니다(이후엔 권역 관리자에게 요청). 한 방문에는 기록을 <b>1건</b>만 작성할 수 있어, 이미 작성한 방문은 수정 모드로 열립니다.</Note>
        <ShotMobile src={S("report")} alt="방문 기록 작성 화면" caption="방문 기록 작성 — 컨디션·활력징후·특이사항 메모·방문 사진" />
        <GoTo links={[{ href: "/m/report", label: "방문 기록 작성 열기" }]} />
      </Section>

      <Section id="cases" title="7. 내 케이스·어르신">
        <Lead>담당 어르신 목록과 개별 케이스 상세를 봅니다.</Lead>
        <Steps items={[
          "하단 '케이스' 탭에서 담당 어르신 목록을 봅니다(이름·상태·우선순위 필터).",
          "어르신을 눌러 케이스 상세로 들어가 활력 추세·복약·일정·기록·가족 정보를 확인합니다.",
          "케이스 상세에서 복약 정보를 추가·수정·중단합니다(담당 어르신 한정).",
          "케이스 상태(배정→돌봄→종결)를 변경하고 매니저 메모를 편집합니다.",
        ]} />
        <ShotMobile src={S("cases")} alt="내 케이스 목록 화면" caption="내 케이스 — 담당 어르신 목록과 상태 필터" />
        <GoTo links={[{ href: "/m/cases", label: "케이스 목록" }, { href: "/m/case", label: "케이스 상세" }]} />
      </Section>

      <Section id="chat" title="7-1. 보호자 메시지">
        <Lead>담당 어르신의 보호자와 앱 안에서 1:1 메시지를 주고받습니다. 전화번호가 없어도 쓸 수 있는 인앱 채널입니다.</Lead>
        <Steps items={[
          "케이스 카드나 어르신 상세의 '메시지' 버튼을 누르면 해당 어르신 보호자와의 대화가 열립니다.",
          "메시지를 보내면 보호자에게 알림이 가고, 보호자의 답장도 알림으로 받습니다.",
          "알림함의 메시지 알림을 누르면 해당 대화로 바로 이동합니다.",
        ]} />
        <Note>대화는 본인이 <b>담당하는(케어 관계가 있는)</b> 어르신의 보호자와만 가능합니다. 받은 메시지는 대화를 열면 자동으로 읽음 처리됩니다.</Note>
        <GoTo links={[{ href: "/m/chat", label: "메시지 열기" }]} />
      </Section>

      <Section id="match" title="8. AI 매칭 제안">
        <Lead>새로 배정 제안된 어르신을 검토하고 수락·보류·거절합니다.</Lead>
        <Steps items={[
          "홈의 '새 매칭 제안' 배너 또는 매칭 화면에서 제안 카드를 봅니다.",
          "좌우로 넘기며 6개 차원(거리·자격·가용·부하·이력·평가) 점수로 적합도를 비교합니다.",
          "수락·보류·거절을 선택합니다. 수락하면 일정에 자동으로 추가됩니다.",
        ]} />
        <Note>차원별 점수는 실제 데이터로 산출됩니다 — 거리는 어르신·내 위치 기준, 가용은 이번 주 근무시간 여유(취소 방문 제외), 평가는 보호자·어르신이 남긴 별점입니다.</Note>
        <ShotMobile src={S("match")} alt="AI 매칭 제안 화면" caption="AI 매칭 제안 — 카드 스와이프, 수락/보류/거절" />
        <GoTo links={[{ href: "/m/match", label: "매칭 제안 열기" }]} />
      </Section>

      <Section id="reports" title="9. 내 방문 기록 조회">
        <Lead>그동안 작성한 방문 기록을 모아 봅니다.</Lead>
        <Steps items={[
          "내 방문 기록 화면에서 최근 기록을 날짜·어르신명·활력 요약으로 확인합니다.",
          "기록을 눌러 상세를 보고, 24시간 이내면 수정합니다.",
        ]} />
        <GoTo links={[{ href: "/m/reports", label: "내 방문 기록 열기" }]} />
      </Section>

      <Section id="me" title="10. 내 정보">
        <Lead>프로필과 계정 설정을 관리하고, 소속 기관 변경을 신청합니다.</Lead>
        <Steps items={[
          "하단 '마이' 탭에서 프로필 사진을 변경·삭제하고, 이름·연락처를 편집합니다.",
          "비밀번호를 변경하고 알림 카테고리별(앱·문자) 수신 여부를 설정합니다.",
          "소속을 옮겨야 하면 '소속 기관 변경 신청'으로 이동을 요청합니다(운영자 승인 후 반영).",
          "바로가기로 알림함·일정·케이스·지도에 빠르게 이동하고, 이용약관·개인정보처리방침을 확인합니다.",
          "로그아웃은 마이 화면 하단에서 합니다.",
        ]} />
        <Note>소속 기관 변경은 승인 큐(org_transfer)를 거쳐 운영자가 승인하면 소속 기관·권역이 자동으로 이동됩니다. 변경 신청 중에는 진행 상태가 마이 화면에 표시됩니다.</Note>
        <ShotMobile src={S("me")} alt="내 정보 화면" caption="마이 — 프로필 사진·연락처·비밀번호·알림 설정·소속 변경·바로가기" />
        <GoTo links={[{ href: "/m/me", label: "내 정보 열기" }]} />
      </Section>

      <Section id="flow" title="11. 업무 흐름">
        <Lead>현장 방문 한 건의 표준 흐름입니다. 썸네일을 탭하면 원본 화면이 열립니다.</Lead>
        <FlowStripMobile steps={[
          { src: S("schedule"), label: "일정 확인" },
          { src: S("map"),      label: "지도·내비" },
          { src: S("visit"),    label: "방문·체크인" },
          { src: S("report"),   label: "기록 작성" },
        ]} />
      </Section>

      <Section id="faq" title="12. 자주 묻는 질문 · 문의">
        <p style={{ margin: "10px 0 4px", fontWeight: 700, color: "var(--ink-1)", fontSize: 13 }}>Q. 방문 기록을 잘못 저장했어요. 수정되나요?</p>
        <Lead>작성 후 24시간 이내면 직접 수정할 수 있습니다. 그 이후엔 권역 관리자에게 수정을 요청하세요.</Lead>
        <p style={{ margin: "12px 0 4px", fontWeight: 700, color: "var(--ink-1)", fontSize: 13 }}>Q. 매칭 제안을 거절하면 어떻게 되나요?</p>
        <Lead>거절한 제안은 다른 매니저에게 다시 매칭됩니다. 수락하면 일정에 자동 추가됩니다.</Lead>
        <p style={{ margin: "12px 0 4px", fontWeight: 700, color: "var(--ink-1)", fontSize: 13 }}>Q. 내비게이션이 안 열려요.</p>
        <Lead>지도 화면에서 설치된 내비 앱을 선택하세요. 기본 내비를 저장해두면 다음부터 바로 열립니다.</Lead>
        <div style={{ marginTop: 16, padding: 14, background: "var(--bg-sub)", borderRadius: 12, fontSize: 12, color: "var(--ink-2)", lineHeight: 1.7 }}>
          <div style={{ fontWeight: 800, color: "var(--ink-1)", marginBottom: 4 }}>운영지원 문의</div>
          support@care.local · {supportPhone()} (평일 09:00–18:00)
        </div>
      </Section>
    </ManualMobileShell>
  );
}

export { ManagerManual };
